import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-card-doc-footer',
    template: `<ng-content></ng-content>`,
    standalone: false
})
export class CardDocFooterComponent {
  @HostBinding('class') hostClass = 'lui-card-doc-footer';
}
